<div *ngIf="campus" class="d-flex flex-row justify-content-start align-items-center custom-header-menu">

    <!-- Logo -->
    <div class="d-block">
        <a [routerLink]="urlHome"><img class="custom-header-menu-logo" [src]="logoCampus"></a>
    </div>

    <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">

        <!-- Campus -->
        <button *ngIf="urlCampus" mat-button [routerLink]="urlCampus">
            <span class="material-icons me-2">language</span>
            <span>El Campus</span>
        </button>
        
        <!-- Goals -->
        <button *ngIf="urlGoals" mat-button [routerLink]="urlGoals">
            <span class="material-icons me-2">explore</span>
            <span>Objetivos</span>
        </button>

        <!-- Professorate -->
        <button *ngIf="urlProfessorate" mat-button [routerLink]="urlProfessorate">
            <span class="material-icons me-2">school</span>
            <span>Profesorado</span>
        </button>

        <!-- Courses -->
        <button mat-button [matMenuTriggerFor]="editionMenu" *ngFor="let edition of this.campus.editions" (click)="getEditionLinks(edition)">
            <span class="material-icons me-2">{{ getEditionIcon(edition) }}</span>
            <span>{{ edition.nameMenu }}</span>
        </button>
        
        <mat-menu #editionMenu="matMenu">
            <button *ngIf="urlCourses"        mat-menu-item [routerLink]="urlCourses">Cursos</button>
            <button *ngIf="urlSchedulePrices" mat-menu-item [routerLink]="urlSchedulePrices">Horarios y precios</button> 
            <button *ngIf="urlFaq"            mat-menu-item [routerLink]="urlFaq">Preguntas frecuentes</button>
        </mat-menu>

        <!-- Enrollments -->
        <button mat-button *ngIf="checkEnrollmentsOpen()" (click)="goToEnrollmentsPage()">
            <span class="material-icons me-2">assignment</span>
            <span>Inscripciones</span>
        </button>

        <!-- Contact -->
        <button *ngIf="urlContact" mat-button [routerLink]="urlContact">
            <mat-icon class="me-2">perm_phone_msg</mat-icon>
            <span>Contacto</span>
        </button>
        
    </div>

    <div class="flex-grow-1"></div>
    
    <div class="d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">

        <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
            <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #mobileMenu="matMenu">

            <!-- Campus -->
            <button *ngIf="urlCampus" mat-menu-item [routerLink]="urlCampus">
                <span class="material-icons me-2">language</span>
                <span>El Campus</span>
            </button>

            <!-- Goals -->
            <button *ngIf="urlGoals" mat-menu-item [routerLink]="urlGoals">
                <span class="material-icons me-2">explore</span>
                <span>Objetivos</span>
            </button>

            <!-- Professorate -->
            <button *ngIf="urlProfessorate" mat-menu-item [routerLink]="urlProfessorate">
                <span class="material-icons me-2">school</span>
                <span>Profesorado</span>
            </button>

            <!-- Courses -->
            <button mat-menu-item [matMenuTriggerFor]="editionMobileMenu" *ngFor="let edition of this.campus.editions" (click)="getEditionLinks(edition)">
                <span class="material-icons me-2">{{ getEditionIcon(edition) }}</span>
                <span>{{ edition.nameMenu }}</span>
            </button>
            
            <!-- Enrollments -->
            <button mat-menu-item *ngIf="checkEnrollmentsOpen()" (click)="goToEnrollmentsPage()">
                <span class="material-icons me-2">assignment</span>
                <span>Inscripciones</span>
            </button>

            <!-- Contact -->
            <button *ngIf="urlContact" mat-menu-item [routerLink]="urlContact">
                <mat-icon class="me-2">perm_phone_msg</mat-icon>
                <span>Contacto</span>
            </button>

        </mat-menu>
        
        <mat-menu #editionMobileMenu="matMenu">
            <button *ngIf="urlCourses"        mat-menu-item [routerLink]="urlCourses">Cursos</button>
            <button *ngIf="urlSchedulePrices" mat-menu-item [routerLink]="urlSchedulePrices">Horarios y precios</button> 
            <button *ngIf="urlFaq"            mat-menu-item [routerLink]="urlFaq">Preguntas frecuentes</button>
        </mat-menu>

    </div>

</div>